import React from "react";
import SharedPages from "./pages/shared-pages";
import NotebookPageHeading from "organisms/notebook-page-heading/notebook-page-heading";

const SharedPagesDisplay = () => {
    return (
        <>
            <NotebookPageHeading
                onSharePageClick={() => {}}
                onCreatePageClick={() => {}}
            />
            <SharedPages />
        </>
    );
};

export default SharedPagesDisplay;
